// Get the device language
const getLanguage = () => {
  const [language] = navigator.languages || [navigator.language || navigator.userLanguage];
  return language;
};
export default getLanguage;
